import React from 'react'

export default function excelFolder(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 32 36"
      >
        <g class="xlsFolder 2 (1) 1">
          <path
            fill="#217346"
            d="M15.02 14.98v8.27H6.88v8.92h20.98V14.98H15.02Zm8.77.66h3.43v3.48h-3.43v-3.48Zm-4.71 8.26v3.48h-3.43V23.9h3.43Zm4.07 3.48h-3.43V23.9h3.43v3.48Zm-3.43-4.12v-3.48h3.43v3.48h-3.43Zm0-7.62h3.43v3.48h-3.43v-3.48Zm-4.07 0h3.43v3.48h-3.43v-3.48Zm0 4.14h3.43v3.48h-3.43v-3.48Zm-4.06 4.12h3.43v3.48h-3.43V23.9Zm-4.07 0h3.43v3.48H7.52V23.9Zm3.43 7.63H7.52v-3.48h3.43v3.48Zm4.07 0h-3.43v-3.48h3.43v3.48Zm4.06 0h-3.43v-3.48h3.43v3.48Zm4.07 0h-3.43v-3.48h3.43v3.48Zm4.07 0h-3.43v-3.48h3.43v3.48Zm0-4.15h-3.43V23.9h3.43v3.48Zm-3.43-4.12v-3.48h3.43v3.48h-3.43Z"
            className='st1'
          />
          <path
            fill="#217346"
            d="M30.32 9.98v21.7c0 1.68-1.4 2.99-2.99 2.99H6.65c-1.68 0-2.99-1.4-2.99-2.99V5.49c0-1.68 1.31-3.09 2.99-3.09h16.09c.47 0 1.03.19 1.31.56l5.71 5.61c.28.37.56.84.56 1.4v.01Z"
             className='st1'
            opacity=".1"
          />
          <path
            fill="#217346"
            d="m30.7 8.06-5.99-5.8c-.28-.37-.84-.56-1.31-.56H6.56a3.15 3.15 0 0 0-3.18 3.18V32.2c0 1.78 1.4 3.18 3.18 3.18h21.61c1.78 0 3.18-1.4 3.18-3.09V9.65c.09-.65-.19-1.22-.65-1.59Zm-.47 23.3c0 1.59-1.31 2.99-2.9 2.99H7.4c-1.59 0-2.9-1.31-2.9-2.99V5.72c0-1.59 1.31-2.99 2.9-2.99h15.44c.47 0 .94.19 1.31.56l5.52 5.43c.37.37.65.94.56 1.5v21.14Z"
             className='st1'
          />
          <path
            fill="#217346"
            d="M1.61 5.44h15.66c.51 0 .92.42.92.96v6.01c0 .53-.41.96-.92.96H.69V6.41c0-.53.41-.94.92-.94v-.03Z"
             className='st1'
          />
          <path
            fill="#375B3F"
            d="M18.12 12.27v.12c0 .53-.41.96-.92.96H.63V6.39c0-.53.41-.96.92-.96h.48V7.9c0 2.41 1.87 4.37 4.2 4.37h11.9-.01Z"
             className='st2'
          />
          <path
            fill="#375B3F"
            d="m.63 13.34 2.78 3.28v-3.28H.63Z"
            className='st2'
            opacity=".3"
          />
          <g class="Group">
            <g class="Group">
              <path
                fill="#F1F2F2"
                d="M4.066 11 5.14 8.98 4.127 7.074H5.2l.301.694c.049.088.095.185.14.29.043.104.092.22.144.35h.024a44.864 44.864 0 0 1 .247-.64l.272-.694h1.03L6.347 9.028 7.419 11H6.346l-.35-.748-.145-.313a42.56 42.56 0 0 0-.145-.338h-.024c-.04.12-.082.233-.126.338l-.133.313-.332.748H4.066Zm3.866 0V7.074h.965v3.118h1.52V11H7.932Zm4.216.072a2.3 2.3 0 0 1-.778-.138 2.012 2.012 0 0 1-.693-.434l.506-.622c.14.117.3.207.476.272.177.06.348.09.513.09.169 0 .293-.028.374-.084a.273.273 0 0 0 .127-.241.233.233 0 0 0-.073-.181.625.625 0 0 0-.187-.12 6.57 6.57 0 0 0-.29-.122l-.5-.21a1.54 1.54 0 0 1-.392-.23 1.157 1.157 0 0 1-.295-.355 1.106 1.106 0 0 1-.109-.5c0-.222.06-.421.181-.598.125-.18.294-.326.507-.434a1.65 1.65 0 0 1 .747-.163c.238 0 .467.042.688.127.225.084.422.207.59.368l-.5.627a1.623 1.623 0 0 0-.398-.217 1.077 1.077 0 0 0-.38-.073.636.636 0 0 0-.337.079.256.256 0 0 0-.12.229c0 .068.023.126.072.175.048.048.116.09.204.126.093.036.197.079.314.127l.489.193c.16.064.297.147.41.247a.942.942 0 0 1 .265.35c.064.133.096.291.096.476 0 .221-.058.426-.175.615a1.287 1.287 0 0 1-.512.452 1.818 1.818 0 0 1-.82.17Z"
                class="XLS"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}
